import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchSettings } from "../services/api";

const SettingsContext = createContext(null);

const fallback = {
  email: "sales@bestformedals.com",
  phone: "+852 3050 1288",
  whatsapp: "+852 6000 1288",
  addressCN: "Zhao Lin Industrial 2nd Rd, Xie Gang, Dongguan, Guangdong, China 523595",
  offices: [
    { city: "Hong Kong", role: "Headquarters" },
    { city: "United Kingdom", role: "European Sales Office" },
    { city: "Spain", role: "Southern Europe Office" },
    { city: "Atlanta, USA", role: "Coming Soon" },
  ],
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(fallback);

  const load = async () => {
    try {
      const data = await fetchSettings();
      setSettings({ ...fallback, ...data });
    } catch (e) {
      // keep fallback
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, refresh: load }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  return ctx || { settings: fallback, refresh: () => {} };
};
